import { BLACK_900, BLUE_500, BLUE_GREY_200, BLUE_GREY_300, BLUE_GREY_400, GREEN_400, LILAC_300, LILAC_400, LILAC_500, LILAC_600, RED_400, TRANSPARENT, WHITE, YELLOW_400 } from './../colors';
var stateConfig = {
  default: {
    stepsBackgroundColor: BLUE_500,
    counterColor: WHITE,
    borderColor: BLUE_500,
    typographyColor: BLACK_900,
    connectorColor: BLUE_500
  },
  success: {
    stepsBackgroundColor: GREEN_400,
    iconName: 'CheckboxIcon',
    borderColor: GREEN_400,
    typographyColor: BLACK_900,
    connectorColor: GREEN_400
  },
  warning: {
    stepsBackgroundColor: YELLOW_400,
    iconName: 'AlertMediumIcon',
    borderColor: YELLOW_400,
    typographyColor: BLACK_900,
    connectorColor: YELLOW_400
  },
  danger: {
    stepsBackgroundColor: RED_400,
    iconName: 'CancelIcon',
    borderColor: RED_400,
    typographyColor: BLACK_900,
    connectorColor: RED_400
  },
  'in-progress': {
    stepsBackgroundColor: WHITE,
    borderColor: GREEN_400,
    counterColor: BLACK_900,
    typographyColor: BLACK_900,
    connectorColor: GREEN_400
  },
  disabled: {
    typographyColor: LILAC_500,
    stepsBackgroundColor: LILAC_300,
    borderColor: LILAC_600,
    counterColor: LILAC_600,
    connectorColor: LILAC_300
  },
  loading: {
    stepsBackgroundColor: LILAC_400,
    progressColor: BLUE_500,
    progressPercent: 0,
    typographyColor: BLACK_900,
    connectorColor: LILAC_400
  },
  upcoming: {
    stepsBackgroundColor: TRANSPARENT,
    borderColor: LILAC_300,
    typographyColor: BLACK_900,
    counterColor: BLACK_900
  }
};
var stateConfigWhite = {
  default: {
    stepsBackgroundColor: BLUE_500,
    typographyColor: BLACK_900,
    counterColor: WHITE,
    borderColor: BLUE_500
  },
  success: {
    stepsBackgroundColor: GREEN_400,
    iconName: 'CheckboxIcon',
    typographyColor: BLACK_900,
    borderColor: GREEN_400
  },
  warning: {
    stepsBackgroundColor: YELLOW_400,
    iconName: 'AlertMediumIcon',
    typographyColor: BLACK_900,
    borderColor: YELLOW_400
  },
  danger: {
    stepsBackgroundColor: RED_400,
    iconName: 'CancelIcon',
    typographyColor: BLACK_900,
    borderColor: RED_400
  },
  'in-progress': {
    stepsBackgroundColor: TRANSPARENT,
    progressColor: BLACK_900,
    borderColor: BLUE_GREY_400,
    typographyColor: BLACK_900
  },
  upcoming: {
    stepsBackgroundColor: TRANSPARENT,
    borderColor: LILAC_300,
    typographyColor: BLACK_900
  },
  disabled: {
    typographyColor: BLACK_900,
    stepsBackgroundColor: BLUE_GREY_200,
    borderColor: BLUE_GREY_400,
    counterColor: BLUE_GREY_400
  },
  loading: {
    stepsBackgroundColor: TRANSPARENT,
    progressColor: BLUE_500,
    progressPercent: 0,
    counterColor: BLACK_900
  }
};
export var stepperConfig = {
  direction: 'vertical',
  theme: 'light',
  size: 'md',
  stepperConnectorColor: LILAC_600,
  steps: [],
  config: {
    sm: {
      stepperSize: 24,
      state: Object.assign({}, stateConfig)
    },
    md: {
      stepperSize: 32,
      state: Object.assign({}, stateConfig)
    },
    lg: {
      stepperSize: 40,
      state: Object.assign({}, stateConfig)
    },
    multiLevelStepperSize: {
      mobile: {
        L1: 24,
        L2: 12,
        L3: 8
      },
      desktop: {
        L1: 28,
        L2: 16,
        L3: 12
      }
    }
  }
};
export var stepperWhiteConfig = Object.assign(Object.assign({}, stepperConfig), {
  theme: 'light',
  stepperConnectorColor: BLUE_GREY_300,
  config: {
    sm: {
      stepperSize: 24,
      state: Object.assign({}, stateConfigWhite)
    },
    md: Object.assign(Object.assign({}, stepperConfig.config.md), {
      state: Object.assign({}, stateConfigWhite)
    }),
    lg: Object.assign(Object.assign({}, stepperConfig.config.lg), {
      state: Object.assign({}, stateConfigWhite)
    }),
    multiLevelStepperSize: {
      mobile: {
        L1: 24,
        L2: 12,
        L3: 12
      },
      desktop: {
        L1: 28,
        L2: 12,
        L3: 12
      }
    }
  }
});
export default {
  light: stepperConfig,
  dark: stepperConfig,
  white: stepperWhiteConfig
};